/* eslint-disable max-len */
<template>
  <div class="dhs-desktop">
    <div class="product-container mb-5">
      <div class="hero-container">
        <div class="background-circle"></div>
      </div>
      <ScrollFader targetId="main-header">
        <div slot-scope="{ SFopacity }" class="vehicle-info-container smaller-container-wrapper mb-5 mx-auto px-0">
          <div class="main-header" :style="`opacity:${SFopacity}; transform: translateY(${(1 - SFopacity) * 100}px)`">
            <div v-if="vehicleString">
              <h1 class="text-white vehicle-info">
                {{ vehicleString }}
              </h1>
            </div>
            <div v-else>
              <h1 class="text-white vehicle-info" v-html-safe="$t('message.DHS.header')"></h1>
            </div>
          </div>
        </div>
      </ScrollFader>

      <div v-if="vehicleString && showSpotlight" class="smaller-container-wrapper spotlight-dhs px-0 pt-4">
        <p class="lead mt-0">{{ $t('message.DHS.exploreWhat') }}</p>
        <SpotlightDHSBanner></SpotlightDHSBanner>
      </div>

      <div class="smaller-container-wrapper px-0 pt-4">
        <p class="lead">{{ $t('message.DHS.getAnswers') }}</p>
        <div v-for="(product, index) in filteredSubscribedProducts" :key="index" class="product avr-card">
          <router-link class="product-link d-flex" :data-cy="product" :to="getProductHomeRoute(product)">
            <div class="state">
              <template v-if="getProductHomeState[product].state === 'complete'">
                <div class="check-container"></div>
                <img
                  class="state-icon complete"
                  src="@/assets/check-circle-green-fill.svg"
                  alt="Check circle green"
                  width="16"
                  height="16"
                />
              </template>
            </div>
            <div class="dhs-right d-flex align-items-center">
              <div class="icon-container img-wrap">
                <font-awesome-icon
                  class="icon my-auto"
                  :icon="['far', `${iconMap[product]}`]"
                  :style="iconCss(product)"
                ></font-awesome-icon>
              </div>
            </div>
            <div class="title-container d-flex align-items-center">
              <div>
                <h5 class="product-header">
                  {{ $t(`message.DHS.${getProductHomeState[product].name}.header`) }}
                </h5>
                <div class="ml-0 starbar-container" v-if="getProductHomeState[product].name === 'reviews'">
                  <MobialisStarBar
                    class="mb-0"
                    :reviewCount="businessReviewOverallRatingCount"
                    :aggregateRating="businessReviewOverallRating"
                    :spacing="2"
                    :stacked="false"
                    size="medium"
                    :reviewCountLabel="$t('message.DHS.reviews.reviewCount')"
                  >
                  </MobialisStarBar>
                </div>
                <p v-else class="ml-0 mt-1 mb-0 text-muted p-small">
                  {{ $t(`message.DHS.${getProductHomeState[product].name}.value`) }}
                </p>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import ScrollFader from '@/components/renderless/ScrollFader';
import { AVRProducts } from '../../utils/enums';

const SpotlightDHSBanner = () => import('@/modules/spotlight/containers/SpotlightDHSBanner.vue');

export default {
  name: 'desktop-DHS',
  components: {
    ScrollFader,
    SpotlightDHSBanner,
  },
  computed: {
    ...mapGetters('vehicle', ['vehicleString']),
    ...mapGetters({
      languageCode: 'user/getLanguageCodeForNumericalInternationalization',
    }),
    ...mapGetters(['getProductHomeState', 'getProductHomeRoute']),
    ...mapGetters('business', ['getSubscribedProducts']),
    ...mapGetters('reviews', ['businessReviewOverallRating', 'businessReviewOverallRatingCount']),
    filteredSubscribedProducts() {
      // Spotlight is always at the top
      // Make sure we have the product listed under the DHS data
      return this.getSubscribedProducts.filter(
        product => product !== AVRProducts.SPOTLIGHT && this.getProductHomeState[product]
      );
    },
    showSpotlight() {
      return this.getSubscribedProducts.includes(AVRProducts.SPOTLIGHT);
    },
  },
  methods: {
    ...mapMutations(['trade/RESET_VEHICLE', 'insurance/RESET_INSURANCE_VEHICLE_SELECTION']),
    iconCss(product) {
      // the spin icon is a wee bit different than the rest because it's custom which means we need custom css for it.
      if (product === 'spin') {
        return {
          paddingTop: '0px',
          paddingBottom: '21px',
          paddingLeft: '0',
          paddingRight: '6px',
        };
      }
      return {};
    },
  },
  data() {
    return {
      iconMap: {
        reviews: 'thumbs-up',
        credit: 'tachometer-fast',
        trade: 'exchange-alt',
        insurance: 'shield-check',
        testDrive: 'car',
        spin: 'av-spin',
      },
    };
  },
  mounted() {
    if (!this.$route.query.vin) {
      this['insurance/RESET_INSURANCE_VEHICLE_SELECTION']();
    }
  },
};
</script>

<style scoped lang="scss">
@import 'src/assets/scss/variables';
.hero-container {
  position: absolute;
  overflow: hidden;
  width: 100%;
  height: 355px;
  left: 0;
  top: 38px;

  @media (min-width: 576px) {
    height: 325px;
    top: 38px;
  }

  .background-circle {
    position: absolute;
    border-radius: 50%;
    background: $primary;
    max-height: 625px;
    height: 240px;
    width: 750px;
    top: 17%;
    left: 50%;
    transform: translate(-50%, -50%);
    @media (min-width: 576px) {
      width: 1200px;
      height: 280px;
      top: 20%;
    }
    @media (min-width: 750px) {
      width: 140%;
      top: 20%;
    }
  }
}
.icon {
  height: 100%;
  width: 48px;
  padding: 25%;
  vertical-align: middle;
  color: $primary;
}
.product-container {
  margin-top: 24px;
  background: white;
  @media (min-width: 576px) {
    margin-top: 38px;
  }
}
.product {
  margin: auto auto 12px;
  width: 100%;
  padding: 5px 0;
  @media (min-width: 576px) {
    padding: 0;
    height: 94px;
  }
  .product-link {
    display: block;
    height: 100%;
    &:hover {
      text-decoration: none;
    }
    h4 {
      margin-top: 12px;
      color: #19222b;
    }
  }
}

.avr-card {
  position: relative;
  padding: 0;
  a.product-link {
    padding: 24px 32px;
  }
}

.img-wrap {
  width: 46px;
  height: 46px;
  border-radius: 6px;
  background-color: $primary-light-background2;
  left: 16px;
}

.state {
  top: 0px;
  right: 0px;
  border-radius: 50%;
  height: 16px;
  position: absolute;
}
.check-container {
  background: rgb(225, 255, 230);
  border-radius: 0px 6px 0px 100px;
  height: 39px;
  width: 39px;
  top: 0px;
  right: 0px;
  position: relative;
}
.state-icon {
  top: 8px;
  right: 8px;
  position: absolute;
}

.starbar-container {
  max-width: 220px;
}

.lead {
  color: #19222b;
  font-size: 18px;
  @media (min-width: 576px) {
    font-size: 20px;
  }
}
.product-header {
  color: #19222b;
  line-height: 20px;
  margin-bottom: 5px;
}
.title-container {
  margin-left: 16px;
  @media (min-width: 576px) {
    margin-left: 24px;
  }
}
.main-header {
  min-height: 110px;
  display: flex;
  align-items: center;
  .vehicle-info {
    line-height: 35px;
    @media (min-width: 576px) {
      line-height: 45px;
    }
  }
  p {
    height: 24px;
  }
}
</style>
